




























import {Vue, Component, Prop} from 'vue-property-decorator'
import Confirmacion from '@/components/Confirmacion.vue'
import {State, Action, Mutation} from 'vuex-class'
import TablaReportes from '@/components/TablaReportes.vue'
import DetalleRepDespachoAlmacigueras from '@/components/Reportes/DetalleRepDespachoAlmacigueras.vue'
import { reporteriaAxios } from '@/plugins/axios';
import ResponseCustom from '@/entidades/ResponseCustom';
import { mensajes } from '@/plugins/notify'
@Component({
    components:{
        Confirmacion,
        TablaReportes,
        DetalleRepDespachoAlmacigueras
    }
})

export default class extends Vue
{
    componentName='Confirmacion'
    modal=false;
    modal2=false;
    desde='';
    hasta='';
    desdeModal=false;
    hastaModal=false;
    headers:any[]= 
    [
        {
          text: 'Hacienda',
          align: 'start',
          sortable: false,
          value: 'haciendaName'
        },
        {
          text: 'Orden Interna',
          align: 'start',
          sortable: false,
          value: 'ordenInterna'
        },
        {
          text: 'Costo',
          align: 'end',
          sortable: false,
          value: 'costo'
        },
        { text: 'Acciones', align: 'center', value: 'acciones', sortable: false },        
    ];
    cabeceraDetalles:any[]=[
        {
          text: 'Hacienda',
          align: 'start',
          sortable: false,
          value: 'haciendaName'
        },
        {
          text: 'Orden Interna',
          align: 'end',
          sortable: false,
          value: 'ordenInterna'
        },
        {
          text: 'Costo',
          align: 'end',
          sortable: false,
          value: 'costo'
        },
    ]
    items=new Array();
    detalles=new Array();

    async cargarDatos(){
        await reporteriaAxios({
            url:`CostoFormacionHacienda/ObtenerCostoTodos`,
            method:'get',
        }).then((data)=>{
            var resp:ResponseCustom<any>=data.data;
            console.log("Respuesta; ", resp)
            if(resp.isSuccess){
                this.items=resp.isResult;
            }else{
                mensajes.error('No se pudieron cargar los datos: '+resp.isMessage)
            }
        }).catch((err)=>{
            console.log("Error: ", err)
            mensajes.errorDeConexion()
        })
    }
    async cargarDatosFiltrados(fechas:any){
        await reporteriaAxios({
            url:`CostoFormacionHacienda/ObtenerCostoFecha`,
            method:'POST',
            data:fechas
        }).then((data)=>{
            var resp:ResponseCustom<any>=data.data;
            console.log("Respuesta; ", resp)
            if(resp.isSuccess){
                this.items=resp.isResult;
            }else{
                mensajes.error('No se pudieron cargar los datos: '+resp.isMessage)
            }
        }).catch((err)=>{
            mensajes.errorDeConexion()
        })
    }
    async obtenerPDF(item:any){
         console.log('Llamdo en el padre con: ', item)
        await reporteriaAxios({
            url:`DespachoAlmaciguera/GenerarPdf/${item.id}`,
            method:'get',
            responseType: 'blob'
        }).then((data)=>{
            const url = window.URL
                .createObjectURL(new Blob([data.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'despachoalmaciguera'+this.generarNombre(item.id)+'.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }).catch((err)=>{
            mensajes.errorDeConexion()
        })
    }
    generarNombre(id:number){
        var limite=9;
        var cantidadDigitosId=id.toString().length;
        var restantes=limite-cantidadDigitosId;
        var salida='';
        for (let index = 0; index < restantes; index++) {
            salida=salida+'0';
        }
        return salida+id.toString();
    }
    async verDetalles(item:any){
        console.log('Llamdo en el padre con: ', item)
        await reporteriaAxios({
            url:`CostoFormacionHacienda/ObtenerCostoHaciendaId/${item.haciendaId}`,
            method:'get',
        }).then((data)=>{
            var resp:ResponseCustom<any>=data.data;
            console.log("Respuesta; ", resp)
            if(resp.isSuccess){
                this.detalles=resp.isResult;
                this.modal=true;
                this.componentName='DetalleRepDespachoAlmacigueras'
            }else{
                mensajes.error('Error: '+ resp.isMessage);
            }
        }).catch((err)=>{
            mensajes.errorDeConexion()
        })
    }
    async created() {
        await this.cargarDatos()
    }
}

